import { Component, Inject } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AumDialogRef, MAT_DIALOG_DATA } from '@modeso/aumico-lib-core-fe';
import { IAccount } from '@modeso/types__aumico-lib-annualreport-be';
import { IIncomeAccountSelectionDialogData } from './IIncomeAccountSelectionDialogData.interface';

@Component({
    selector: 'adjustment-income-account-selection',
    templateUrl: 'income-account-selection-popup.component.html',
    styleUrls: ['income-account-selection-popup.component.scss'],
})
export class IncomeAccountSelectionPopupComponent {
    private selectedAccount: IAccount | undefined;
    dialogData: IIncomeAccountSelectionDialogData;
    incomeAccounts: IAccount[] = [];
    constructor(
        private dialogRef: AumDialogRef<IncomeAccountSelectionPopupComponent, IAccount | undefined>,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) private data: IIncomeAccountSelectionDialogData,
    ) {
        this.incomeAccounts = this.data.incomeAccounts;
        this.dialogData = this.data;
        this.addSvgIcon('interface-delete 1');
    }

    public closeDialog(): void {
        this.dialogRef.close(undefined);
    }

    public submitSelection(): void {
        this.dialogRef.close(this.selectedAccount);
    }

    selectedItem(event: MatButtonToggleChange): void {
        this.selectedAccount = event.value;
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }
}
